import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import About from "@/components/About";
import Services from "@/components/Services";
import Sectors from "@/components/Sectors";
import InternationalPractice from "@/components/InternationalPractice";
import Elections from "@/components/Elections";
import Corporate from "@/components/Corporate";
import CaseStudies from "@/components/CaseStudies";
import Clients from "@/components/Clients";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Landing = () => {
  return (
    <div className="bg-white text-black min-h-screen">
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <About />
        <Services />
        <Sectors />
        <InternationalPractice />
        <EditorialMarquee reverse />
        <Elections />
        <Corporate />
        <CaseStudies />
        <Clients />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            color: "#ffffff",
            border: "1px solid #0a0a0a",
            borderRadius: 0,
            fontFamily: "Manrope, sans-serif",
            fontSize: "0.85rem",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
